
export enum AmpEventSourceTypeDozi {
  REACHOUT = 'ReachOutDOZI',
  SFNA = 'SFNA',
  MDNA = 'MDNA',
  DOZI = 'DOZI',
  ZI_LITE = 'ZI-LITE',
}
